const _ = require("underscore");

module.exports = function (number) {
  if (_.isNumber(number) && !_.isNaN(number) && _.isFinite(number)) {
    return `${(number * 100).toFixed(2)}%`;
  }
  return "N/A";
};
